<template>
    
    <div class="">
        <div>
            <b-card no-body style="width: 100%;">
                <b-tabs pills card>
                    <b-tab lazy title="List Sales" >
                        <ListSales :showbacker="false" :active="true" />
                    </b-tab>

                    <b-tab lazy title="New Sale" >
                        <NewSales :showbacker="false" :active="$route.hash.indexOf('#new_sale') > -1 "/>
                    </b-tab>
 <!--                    <b-tab lazy title="View Invoice" :active="$route.hash.indexOf('#view_invoice?') > -1 ">
                        <ViewInvoice :showbacker="false" />
                    </b-tab> -->
                    
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
    import NewSales from "@/components/NewSales"
    import ViewInvoice from "@/components/ViewInvoice"
    import ListSales from "@/components/ListSales"

    export default {
        name: "Sales",
        components: {NewSales, ListSales, ViewInvoice},
        data: function(){
            return {
                userDetails: {properties: {}},
            }
        },
        methods: {},
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
            }
        },

    }
</script>


// WEBPACK FOOTER //
// src/components/Sales.vue